import script from "./QualOtherLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QualOtherLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./QualOtherLanguage.vue?vue&type=style&index=0&id=e9912576&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9912576"]])

export default __exports__